export function local_storage_supported(){
	try{
		localStorage.setItem("test", "test");
		localStorage.removeItem("test");
		return true
	}catch(e){
		return false
	}
}

export function inject_fonts_stylesheet(css_href){
	var xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function(){
		if(Number(this.readyState) === 4 && Number(this.status) === 200){
			inject_raw_style(this.responseText);
			localStorage.VELOX_FONTS = this.responseText
			console.info('Velox fonts loaded.')
		}
	}
	xhr.open("GET", css_href, true);
	xhr.send()
}

export function inject_raw_style(css){
	var head = document.head || document.getElementsByTagName("head")[0],
    	style = document.createElement("style");
	style.type = "text/css";
	if (style.styleSheet){
	  style.styleSheet.cssText = css;
	} else {
	  style.appendChild(document.createTextNode(css));
	}
	head.appendChild(style);
	document.body.className += " is-velox-fonts-loaded";
}

export function get_font_stylesheet(stylesheet_url){
	if( local_storage_supported() && localStorage.VELOX_FONTS ){
		inject_raw_style(localStorage.webFonts)
	}else{
		window.onload = function(){
			inject_fonts_stylesheet(stylesheet_url)
		}
	}
}